"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GenericCorporationProduct_1 = require("../GenericCorporationProduct");
const EPaymentMethod_1 = require("../../../../enums/ProductSubscribed/EPaymentMethod");
const ESubFilesTypes_1 = require("../../../../enums/Subscription/File/ESubFilesTypes");
const EPatrimoineRevenusCorporationGroups_1 = require("../../../../enums/Scpi/Corporation/Groups/EPatrimoineRevenusCorporationGroups");
const EConnaissanceExperienceCorporationGroups_1 = require("../../../../enums/Scpi/Corporation/Groups/EConnaissanceExperienceCorporationGroups");
const ETestAdequationCorporationGroups_1 = require("../../../../enums/Scpi/Corporation/Groups/ETestAdequationCorporationGroups");
const EAutreCgpCorporationGroups_1 = require("../../../../enums/Scpi/Corporation/Groups/EAutreCgpCorporationGroups");
const product = {
    payment_methods: {
        groups: [EPaymentMethod_1.EPaymentMethod.CHEQUE, EPaymentMethod_1.EPaymentMethod.VIREMENT, EPaymentMethod_1.EPaymentMethod.PRELEVEMENT, EPaymentMethod_1.EPaymentMethod.CREDIT, EPaymentMethod_1.EPaymentMethod.CREDIT_CONSORTIUM],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.payment_methods.validationClass,
    },
    patrimoine_revenus: {
        groups: [
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.patrimoineCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.revenusAnnuelsBrutsCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.compositionRevenusSocieteCorporation,
            EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.categorisationMifCorporation,
        ],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.patrimoine_revenus.validationClass,
    },
    connaissance_experience: {
        groups: [
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.experienceProfessionnelleCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.supportPlacementConnaissezCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.supportPlacementPossedezCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.dejaSouscritScpiCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.dejaSouscritScpiPartPiervalCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.dejaSouscritScpiNamePiervalCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.dejaSouscritScpiPremiereSouscriptionCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.dejaSouscritScpiTypeCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.dejaSouscritScpiPartCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.frequenceTransactionCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.modeGestionCorporation,
            EConnaissanceExperienceCorporationGroups_1.EConnaissanceExperienceCorporationGroups.nbOperationsSansConseillerCorporation,
        ],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.connaissance_experience.validationClass,
    },
    test_adequation: {
        groups: [
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.modalitesAchatPartsSCPICorporation,
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.modalitesVentePartsSCPICorporation,
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.accepterNonGarantieCapitalCorporation,
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.accepterRendementNonGarantiCorporation,
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.fiscaliteApplicableScpiCorporation,
            ETestAdequationCorporationGroups_1.ETestAdequationCorporationGroups.periodicitePiervalCorporation,
        ],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.test_adequation.validationClass,
    },
    finance_durable: GenericCorporationProduct_1.GenericCorporationProduct.finance_durable,
    autre_cgp: {
        groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.appreciationClientCorporation, EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.appreciationOperationCorporation],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.autre_cgp.validationClass,
    },
    files: {
        groups: [
            ESubFilesTypes_1.ESubFilesTypes.RIB_CORPORATION,
            ESubFilesTypes_1.ESubFilesTypes.KBIS,
            ESubFilesTypes_1.ESubFilesTypes.CERTIFIED_STATUS,
            ESubFilesTypes_1.ESubFilesTypes.CARD_ID_LEGAL_REPRESENTATIVE,
            ESubFilesTypes_1.ESubFilesTypes.JUSTIFICATIF_DOMICILE_LEGAL_REPRESENTATIVE,
            ESubFilesTypes_1.ESubFilesTypes.JUSTIFICATIF_ORIGINE_FONDS_CORPORATION,
        ],
        validationClass: GenericCorporationProduct_1.GenericCorporationProduct.files.validationClass,
    },
};
exports.default = product;
